module.exports = __webpack_public_path__ + "img/gal_15.4ef92e7f.png";